// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"a15feeafb9c60aa8","665":"cd4bf97f005b5ddf"}[chunkId] + ".js";
};